import { Box, Button, Card, Flex, Overlay, rem, Text, Title } from "@mantine/core"
import Image from "next/image"
import Link from "next/link"
import styles from "./index.module.scss"




const ModelCtaExclusive = () => {
    return (
        <Box bg="white" py={{ base: rem(40), sm: "80px 40px" }} className={styles.cta}>
            <Flex direction="column" className="container">
                <Card radius={rem(16)} bg="#FFF4E8" p={0}>
                    <Flex align="center" justify="space-between" direction={{ base: "column", sm: "row" }}>
                        <Flex flex={1} w={{ sm: "50%" }} p={{ base: rem(24), sm: "40px 52px" }} direction="column" gap={rem(16)}>
                            <Title order={4} fw={700} fz={{ base: rem(24), sm: rem(40) }} lh={{ base: rem(36), sm: rem(60) }}>
                                مــدل‌های انحـصــاری !!!
                            </Title>

                            <Text fw={500} fz={{ base: rem(14), sm: rem(16) }} lh={rem(32)}>
                                اگر هنوز مدل مناسب آشپزخانه‌ی خود را نیافتید، مشاورین ما اینجا هستند تا به شما در پیدا کردن مدل منحصر به‌فرد خود مشاوره بدهند.
                            </Text>

                            <Link href="/product?service_type=cabinet&form_type=Models-details-page-bottom-cta&title=%D8%A8%D8%B1%D8%A7%DB%8C%20%D8%AF%D8%B1%DB%8C%D8%A7%D9%81%D8%AA%20%D9%85%D8%B4%D8%A7%D9%88%D8%B1%D9%87%20%D8%A7%D9%86%D8%AA%D8%AE%D8%A7%D8%A8%20%D8%A8%D9%87%D8%AA%D8%B1%DB%8C%D9%86%20%D9%85%D8%AF%D9%84%20%D8%A7%D8%B2%20%DA%A9%D8%A7%D8%B1%D8%B4%D9%86%D8%A7%D8%B3%D8%A7%D9%86%20%D8%B3%D9%84%D8%A7%D9%85%20%D8%B3%D8%A7%D8%AE%D8%AA%D9%85%D8%A7%D9%86%20%D9%84%D8%B7%D9%81%D8%A7%20%D9%81%D8%B1%D9%85%20%D8%B1%D8%A7%20%D8%AA%DA%A9%D9%85%DB%8C%D9%84%20%DA%A9%D9%86%DB%8C%D8%AF:&unstructured_data=price">
                                <Button
                                    px={rem(16)}
                                    w={{ base: "100%", sm: "fit-content" }}
                                    fw={{ base: 500, sm: 600 }}
                                    fz={rem(16)}
                                >
                                    درخواست مشاوره
                                </Button>
                            </Link>
                        </Flex>

                        <Flex flex={1} w={{ base: "100%", sm: "50%" }} pos="relative" h="100%" mih={300}>
                            <Overlay bg={{ base: "linear-gradient(180deg, #FFF4E8 0.23%, rgba(153, 153, 153, 0) 46.54%)", sm: "linear-gradient(270.24deg, #FFF4E8 0.23%, rgba(153, 153, 153, 0) 46.54%)" }} />

                            <Image
                                src="/images/models/cta-exclusive.png"
                                alt="cta"
                                layout="fill"
                                className={styles.img__cta}
                            />
                        </Flex>
                    </Flex>
                </Card>
            </Flex>
        </Box>
    )
}

export default ModelCtaExclusive